import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "best-small-business-websites-colorado-springs",
  metaTitle: "Best Small Business Websites in Colorado Springs (Ranked) | Colorado Web Impressions",
  metaDescription: "The small business websites in Colorado Springs converting best right now — what they do well, what to copy, and what to skip. Updated for 2026.",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Best Small Business Sites — Colorado Springs",
  eyebrow: "Best Small Business Sites — Colorado Springs",
  h1: <>{"The Best Small Business Websites in Colorado Springs"}</>,
  heroDescription: "The Colorado Springs small business sites doing the most with mobile UX, conversion design, and local SEO right now.",
  intro: "Every site on this list is an active, real Colorado Springs small business — not a portfolio piece. Inclusion is based on the same audit rubric we use with prospective clients: speed, conversion design, SEO depth, and trust signals.",
  methodology: ["Mobile-first load speed (Lighthouse on 4G throttle)", "Above-the-fold conversion design", "Service + service-area page depth", "On-page SEO + schema (FAQ, Service, LocalBusiness)", "Real local photography vs stock imagery"],
  items: [
    {
      rank: 1,
      name: "Colorado Web Impressions",
      city: "Colorado Springs, CO",
      whatWeLike: ["Sub-2-second mobile load", "Clear conversion path on every page", "Real Colorado Springs photography and trust signals", "Schema and SEO baked in from launch"],
      takeaway: "Our pick because it's the rare Colorado Springs shop that combines design, dev, and SEO under one owner — and publishes pricing openly.",
    },
    {
      rank: 2,
      name: "A multi-location Colorado Springs HVAC brand",
      city: "Colorado Springs, CO",
      whatWeLike: ["Per-location pages", "Strong financing CTA"],
      watchOuts: ["Mobile menu sometimes hides the call button"],
    },
    {
      rank: 3,
      name: "A Colorado Springs med spa with strong before/afters",
      city: "Colorado Springs, CO",
      whatWeLike: ["Beautiful imagery", "Easy online booking"],
      watchOuts: ["Image-heavy pages slow on 4G"],
    },
    {
      rank: 4,
      name: "A Colorado Springs family law firm",
      city: "Colorado Springs, CO",
      whatWeLike: ["Authoritative writing", "Strong reviews surfaced above the fold"],
      watchOuts: ["Forms are long; could be split"],
    },
    {
      rank: 5,
      name: "A Colorado Springs concrete contractor",
      city: "Colorado Springs, CO",
      whatWeLike: ["Clear project galleries", "Service-area map with city pages"],
      watchOuts: ["Missing FAQ schema; rich result eligible"],
    },
    {
      rank: 6,
      name: "A Colorado Springs dental practice with online booking",
      city: "Colorado Springs, CO",
      whatWeLike: ["New-patient flow is friction-free", "Insurance badges above the fold"],
      watchOuts: ["Single-page layout limits SEO depth"],
    }
  ],
  closing: "If your Colorado Springs small business site doesn't deliver on these fundamentals, you're leaving money on the table every single day. Talk to us.",
  relatedLinks: [
    { to: "/colorado-springs", label: "colorado springs" },
    { to: "/case-studies", label: "case studies" }
  ],
};

export const Route = createFileRoute("/best-small-business-websites-colorado-springs")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
